import nluApi from '../../api/nlu'
import _ from 'lodash'
import Promise from 'bluebird'

const STATUSES_OF_A_PROCESS = ['LOADING', 'BUILDING', 'READY_TO_PUBLISH', 'PUBLISHING']
const LATEST_VERSION_STATUS = null

export default {
  namespaced: true,

  state: {
    statusSet: {}
  },

  getters: {
    productionTrainStatus (state, getters, rootState, rootGetters) {
      return _.get(rootGetters['knowledgebase/getCurrent'], 'endpoints.PRODUCTION.trainStatus.status')
    },

    currentStatus (state) {
      return _.get(state.statusSet, LATEST_VERSION_STATUS)
    },

    isStatusFeatching (state, getters) {
      return _.includes(STATUSES_OF_A_PROCESS, getters.currentStatus)
    }
  },

  actions: {
    setModelStatuses ({ getters, commit, rootGetters }) {
      const statusSet = {}
      const { versions } = rootGetters['knowledgebase/getCurrent']

      // eslint-disable-next-line lodash/prefer-filter
      _.forEach(versions, (version) => {
        if (!version.isRemoved) {
          _.set(statusSet, version.versionId, version.trainStatus.status)
        }
      })

      commit('SET_STATUS_SET', { ...statusSet, null: getters.productionTrainStatus })
    },

    async fetchStatus ({ rootState, rootGetters, commit, dispatch }, versionId = LATEST_VERSION_STATUS) {
      try {
        if (_.isEmpty(_.get(rootState, 'knowledgebase.current'))) {
          return
        }
        let response = await nluApi.getTrainStatus({
          kbId: _.get(rootState, 'knowledgebase.current'),
          versionId
        })
        commit('SET_STATUS', { version: versionId, status: response.status })
        if (_.includes(STATUSES_OF_A_PROCESS, response.status)) {
          await Promise.delay(5000)
          response = await dispatch('fetchStatus', versionId, true) // keep fetching status
        }

        return response
      } catch (error) {
        await Promise.delay(3000)
        await dispatch('fetchStatus', versionId) // retry to fetch status
      }
    }
  },

  mutations: {
    SET_STATUS (state, { version, status }) {
      console.log('version/status: ', version, status) // eslint-disable-line no-console
      _.set(state, `statusSet.${version}`, status)
    },

    SET_STATUS_SET (state, statusSet) {
      console.log('statusSet: ', statusSet)
      _.set(state, 'statusSet', statusSet)
    }
  }
}
